import { ServiceConfigoption } from '@/modules/Service/types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Typogaphy } from 'vnetwork-ui'

interface PAYGProps {
    data: ServiceConfigoption[]
    onEnableFixedPackages?: () => void
}
const PAYG: React.FC<PAYGProps> = ({ data = [], onEnableFixedPackages }) => {
    const { t } = useTranslation()
    return (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 mt-2 border border-blue-100">
            <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <svg
                        className="w-5 h-5 text-blue-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13 10V3L4 14h7v7l9-11h-7z"
                        />
                    </svg>
                </div>
                <div>
                    <Typogaphy className="text-lg font-semibold text-gray-800 mb-1">
                        {t('services.payg.title')}
                    </Typogaphy>
                    <Typogaphy className="text-sm text-gray-600">
                        {t('services.payg.subtitle')}
                    </Typogaphy>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="bg-white rounded-lg p-4 border border-gray-100 shadow-sm">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                        <Typogaphy className="font-medium text-gray-800">
                            {t('services.payg.feature.flexible')}
                        </Typogaphy>
                    </div>
                    <Typogaphy className="text-sm text-gray-600">
                        {t('services.payg.feature.flexible.desc')}
                    </Typogaphy>
                </div>

                <div className="bg-white rounded-lg p-4 border border-gray-100 shadow-sm">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                        <Typogaphy className="font-medium text-gray-800">
                            {t('services.payg.feature.nocommitment')}
                        </Typogaphy>
                    </div>
                    <Typogaphy className="text-sm text-gray-600">
                        {t('services.payg.feature.nocommitment.desc')}
                    </Typogaphy>
                </div>
            </div>

            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                    <svg
                        className="w-5 h-5 text-amber-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                    <Typogaphy className="font-medium text-amber-800">
                        {t('services.payg.info.title')}
                    </Typogaphy>
                </div>
                <Typogaphy className="text-sm text-amber-700">
                    {t('services.payg.info.desc')}
                </Typogaphy>
            </div>

            {data && data.length > 0 && (
                <div className="mt-4 bg-white rounded-lg border border-gray-200 overflow-hidden">
                    <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                        <Typogaphy className="font-medium text-gray-800">
                            {t('services.payg.settings')}
                        </Typogaphy>
                    </div>
                    <div className="p-4">
                        {data.map((config, index) => (
                            <div
                                key={index}
                                className="flex justify-between items-center py-2 border-b border-gray-100 last:border-b-0"
                            >
                                <Typogaphy className="text-sm font-medium text-gray-700">
                                    {t(config.name)}
                                </Typogaphy>
                                <div className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
                                    {t('services.payg.active')}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {onEnableFixedPackages && (
                <div className="mt-2 pt-2 border-t border-gray-200">
                    <div className="flex items-center justify-between">
                        <div>
                            <Typogaphy className="font-medium text-gray-800 mb-1">
                                {t('services.commitment.enable.title')}
                            </Typogaphy>
                            <Typogaphy className="text-sm text-gray-600">
                                {t('services.commitment.enable.desc')}
                            </Typogaphy>
                        </div>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={onEnableFixedPackages}
                            className="ml-4"
                        >
                            {t('services.commitment.enable.button')}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default PAYG
